import { render, staticRenderFns } from "./login.html?vue&type=template&id=54af4f01&scoped=true&"
import script from "./login.js?vue&type=script&lang=js&"
export * from "./login.js?vue&type=script&lang=js&"
import style0 from "./login.css?vue&type=style&index=0&id=54af4f01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af4f01",
  null
  
)

export default component.exports